import type { CSSProperties } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function ClosingSection({ data }: SectionRenderProps) {
  const source = resolveAssetPath(data.closing.image);
  return (
    <>
      <section className="closing" id="closing" style={{ "--photo": `url("${source}")` } as CSSProperties}>
        <img src={source} alt={data.closing.signature} data-editor-section="closing" data-editor-field="closing.image" />
        <div className="closing-copy">
          {data.closing.title ? <p className="eyebrow" data-editor-section="closing" data-editor-field="closing.title">{data.closing.title}</p> : null}
          {data.closing.message.split(/\n\s*\n/).filter(Boolean).map((line, index) => <p className={`closing-line ${index === 0 ? "closing-line-primary" : ""}`} data-editor-section="closing" data-editor-field="closing.message" key={`${index}-${line}`}>{line}</p>)}
          <p className="closing-signature" data-editor-section="closing" data-editor-field="closing.signature">{data.closing.signature}</p>
        </div>
      </section>
      <footer className="studio-footer">
        <a className="extracted-studio-credit" href="https://invitedstudio.com/" target="_blank" rel="noreferrer" aria-label="Designed by invitedStudio.com">
          <span>Designed by</span>
          <img src={resolveAssetPath("/template-assets/invitedstudio-logo.webp")} alt="invitedStudio.com" />
          <small>Visit invitedstudio.com ↗</small>
        </a>
      </footer>
    </>
  );
}
